<script>
	import { getContext } from 'svelte';
    import { createEventDispatcher } from 'svelte'
	import { mapbox, key } from '../mapbox.js';
    import { yardPriceMarkers } from '../../stores.js';


	const { getMap } = getContext(key);
	const map = getMap();

    const dispatch = createEventDispatcher()
    
    export let yard;
    export let selectedMaterial;

    
    // if we have an image for this yard use that as the marker
        // Create a DOM element for each marker.
    const el = document.createElement('div');

    const materialPrices = yard.accepts.find(item => item.name === selectedMaterial);
    el.innerHTML = createPriceTable(materialPrices);
    el.className = 'marker yard-price-tag-marker';
    el.style.zIndex = '10';
    el.style.backgroundColor = '#ffffff';
    el.style.border = '1px solid #cbd5e1';
    el.style.borderRadius = '6px';
    el.style.boxShadow = '0 2px 6px rgba(0, 0, 0, 0.12)';
    el.style.padding = '3px 7px';
    el.style.fontSize = '11px';
    el.style.fontWeight = '600';
    el.style.color = '#0f172a';
    el.style.lineHeight = '1.3';
    el.style.cursor = 'pointer';

    // create the marker with that HTML element and add it to the map
    let marker = new mapbox.Marker(el, {anchor: 'top-left', offset: [0 , 0]})
    .setLngLat([yard.address.coordinates.lng, yard.address.coordinates.lat])
    .addTo(map);
    
    marker._element.id = 'yard-price-marker-' + yard.id;

    $yardPriceMarkers = [...$yardPriceMarkers, {
            marker: marker,
            label: marker._element.id,
            id: marker._element.id
        }];

    function createPriceTable(data) {
        if (!data || !data.prices || data.prices.length === 0) return '';
        
        let htmlString = '<ul style="margin: 0; padding-left: 0; list-style: none;">';
        
        // Sort the prices by last_updated date in descending order
        data.prices.sort((a, b) => new Date(b.last_updated) - new Date(a.last_updated));
        
        // Check if there is only one price
        if (data.prices.length === 1) {
            htmlString += `<li>$${data.prices[0].price}${data.prices[0].unit ? 'p/' + data.prices[0].unit[0] : ''}</li>`;
        } else {
            let lowestPrice = Number.MAX_SAFE_INTEGER;
            let highestPrice = Number.MIN_SAFE_INTEGER;
            let hasQuantity = false;

            // Iterate through prices to find lowest and highest price, and check for quantity
            data.prices.forEach(priceObj => {
                const price = parseFloat(priceObj.price);
                if (price < lowestPrice) {
                    lowestPrice = price;
                }
                if (price > highestPrice) {
                    highestPrice = price;
                }
                if (priceObj.quantity) {
                    hasQuantity = true;
                }
            });

            // Generate HTML string based on conditions
            if (hasQuantity) {
                data.prices.forEach(priceObj => {
                    htmlString += `<li>$${priceObj.price}${priceObj.unit ? 'p/' + priceObj.unit[0] : ''} ${priceObj.quantity ? 'up to ' + priceObj.quantity : ''}${priceObj.unit ? 'p/' + priceObj.unit[0] : ''}</li>`;
                });
            } else {
                htmlString += `<li>$${lowestPrice}${data.prices[0].unit ? 'p/' + data.prices[0].unit[0] : ''} - $${highestPrice}${data.prices[0].unit ? 'p/' + data.prices[0].unit[0] : ''}</li>`;
            }
        }

        htmlString += '</ul>';
        return htmlString;
    }

</script>
